import React, { useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { useRecoilState } from 'recoil'

import { collectionState } from '../../store'
import Inner from '../../components/Inner'
import GridGallery from '../../components/GridGallery'
import { VideoPlayer } from './VideoPlayer'
import { collectionApi } from '../../api'
import classNames from 'classnames'
import { Helmet } from 'react-helmet-async'

function ShowCollection() {
	const { t } = useTranslation()
	const { slug } = useParams()

	const [collection, setCollection] = useRecoilState(collectionState)

	const getCollection = useCallback(async (collectionSlug) => {
		if (!collectionSlug) return
		const response = await collectionApi.show(collectionSlug)
		setCollection(response)
	}, [])

	useEffect(() => {
		if (!slug) return
	  	getCollection(slug)
	}, [slug])

	return (
		<>
			<Helmet>
				<title>Collections | Belsky Art Gallery</title>
				<meta name="description" content="Browse curated collections of Eduard Belsky's paintings and ceramics. Discover unique series and themes." />
				<link rel="canonical" href="https://eduardbelsky.com/collections" />
				<meta name="robots" content="index, follow" />
				<meta property="og:title" content="Collections | Belsky Art Gallery" />
				<meta property="og:description" content="Browse curated collections of Eduard Belsky's paintings and ceramics. Discover unique series and themes." />
				{/* <meta property="og:image" content="https://eduardbelsky.com/images/og-collections.jpg" /> */}
				<meta property="og:image" content="%PUBLIC_URL%/logo192.png" />
				<meta property="og:url" content="https://eduardbelsky.com/collections" />
			</Helmet>
			<h1 className="sr-only">Art Collection {collection?.title} by Eduard Belsky</h1>
			<Inner>
				{/* <h1 className="text-5xl pt-6">{collection?.title}</h1> */}
				<div className="flex flex-col gap-6 py-8 sm:p-12">
					<div className={classNames("flex items-center w-full text-lg sm:text-base")}>
						{collection?.description}
					</div>
					{collection?.video_url && (
                    <div className="flex justify-center w-full border-b border-slate-200 pb-8">
                        <VideoPlayer
                            className="w-full max-w-3xl h-60 sm:h-80"
                            src={`${collection?.video_url}?autoplay=1`}
						/>
                    </div>
                )}
				</div>
				<GridGallery
					items={(collection?.paintings ?? [])
						.filter(p => p.is_shown)
						.sort((a, b) => b.id - a.id)}
				/>
			</Inner>
		</>
	)
}
export default ShowCollection